// extracted by mini-css-extract-plugin
module.exports = {"SROnly":"sronly-module--SROnly--1KrQ4"};